module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagination"
  }, [(_vm.currentPage > 1) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.goToPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("Prev")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "pagers"
  }, _vm._l((_vm.pagination), function(page) {
    return _c('div', {
      staticClass: "pager"
    }, [(page === _vm.currentPage) ? _c('span', {
      staticClass: "currentPage"
    }, [_vm._v(_vm._s(page))]) : (page === '...') ? _c('span', [_vm._v(_vm._s(page))]) : _c('a', {
      attrs: {
        "to": {
          name: 'Episodes',
          query: {
            page: page
          }
        }
      },
      on: {
        "click": function($event) {
          _vm.goToPage(page)
        }
      }
    }, [_vm._v(_vm._s(page))])])
  })), _vm._v(" "), (_vm.currentPage < _vm.totalPages) ? _c('button', {
    on: {
      "click": function($event) {
        _vm.goToPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("Next")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-944066d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Pagination.vue
// module id = 797
// module chunks = 1